document.addEventListener('DOMContentLoaded', () => {
  // Initialize Swiper
  const swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    slideClass: 'neighborhood-card',
    loop: true,
    autoHeight: true,
    effect: 'cards',
    grabCursor: true,
  });

  // Test Swiper event listeners
  swiper.on('beforeSlideChangeStart', () => {
    console.log('beforeSlideChangeStart event fired');
  });

  swiper.on('slideChangeTransitionStart', () => {
    console.log('slideChangeTransitionStart event fired');
  });

  // Add click event listeners to SVG regions
  document.querySelectorAll('.region').forEach((region) => {
    region.addEventListener('click', () => {
      const neighborhood = region.getAttribute('data-neighborhood');

      // Find the corresponding slide index by data-neighborhood
      const targetSlide = document.querySelector(`.neighborhood-card[data-neighborhood="${neighborhood}"]`);
      const targetIndex = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);

      // Navigate to the corresponding slide
      swiper.slideTo(targetIndex);

      // Update active region styling
      document.querySelectorAll('.region').forEach(r => r.classList.remove('active'));
      region.classList.add('active');
    });
  });

  // Sync map with active slide
  swiper.on('slideChange', () => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeNeighborhood = activeSlide.getAttribute('data-neighborhood');

    // Highlight the corresponding region on the map
    document.querySelectorAll('.region').forEach((region) => {
      region.classList.toggle('active', region.getAttribute('data-neighborhood') === activeNeighborhood);
    });
  });

  // Read More Toggle
  const readMoreButtons = document.querySelectorAll('.read-more-btn');

  readMoreButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const descContent = button.previousElementSibling;

      if (descContent.style.webkitLineClamp === 'unset') {
        descContent.style.webkitLineClamp = '3'; // Limit back to 3 lines
        button.textContent = 'Read More';
      } else {
        descContent.style.webkitLineClamp = 'unset'; // Expand fully
        button.textContent = 'Read Less';
      }

      // Adjust Swiper height
      swiper.updateAutoHeight();
    });
  });

  // Collapse all text when slide changes
  swiper.on('beforeSlideChangeStart', () => {
    console.log('beforeSlideChangeStart event detected: collapsing text');
    readMoreButtons.forEach((button) => {
      const descContent = button.previousElementSibling;

      // Reset the description to collapsed state
      descContent.style.webkitLineClamp = '3';
      button.textContent = 'Read More';
    });

    // Adjust Swiper height in case content was expanded before
    swiper.updateAutoHeight();
  });

  // Tooltip for hoverable regions
  const svg = document.getElementById('dlp-map-svg');

  // Create and append tooltip element to the body
  const tooltip = document.createElement('div');
  tooltip.id = 'tooltip';
  tooltip.classList.add('tooltip');
  document.body.appendChild(tooltip);

  svg.addEventListener('mousemove', (e) => {
    const target = e.target;
    console.log('hovered');
    if (target.classList.contains('hoverable')) {
      tooltip.style.display = 'block';
      tooltip.textContent = target.dataset.label;
      tooltip.style.left = `${e.pageX + 10}px`;
      tooltip.style.top = `${e.pageY + 10}px`;
    } else {
      tooltip.style.display = 'none';
    }
  });

  svg.addEventListener('mouseleave', () => {
    tooltip.style.display = 'none';
  });
});